export default __webpack_public_path__ + "static/media/fireFN24.82af780b.svg";